import React from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import APP_VERSION from 'app-version'

import { sleep } from 'utilities/promises'

const bugsnagClient = Bugsnag.start({
  apiKey:
    typeof window !== 'undefined'
      ? process.env.BUGSNAG_BROWSER_API_KEY
      : process.env.BUGSNAG_SSR_API_KEY,
  releaseStage: process.env.APP_ENV,
  enabledReleaseStages: ['staging', 'production', 'growth'],
  plugins: [new BugsnagPluginReact(React)],
  appVersion: APP_VERSION,
})

export const bugsnagNotifyAsync = async error => {
  await Promise.race([
    sleep(2000), // timeout
    new Promise(resolve => {
      Bugsnag.notify(error, () => {
        console.log('Bugsnag notified!')
        resolve(true)
      })
    }),
  ])
}

export default bugsnagClient
